<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">Update Historical Data
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>

<hr class="my-0">

<mat-dialog-content>
    <form [formGroup]="form" class="grid grid-cols-2 gap-x-4 gap-y-1 p-2">

        <!-- Fields common to standard, annulus, TR-SSSV, and default groups -->
        <ng-container *ngIf="valveGroup !== 'wrsv'">
            <mat-form-field appearance="outline">
                <mat-label>Installed Date</mat-label>
                <input matInput [matDatepicker]="installedDatePicker" formControlName="installedDate">
                <mat-datepicker-toggle matSuffix [for]="installedDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #installedDatePicker></mat-datepicker>
                <mat-error *ngIf="form.get('installedDate')?.hasError('required')">Installed date is
                    required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Part Number</mat-label>
                <input matInput formControlName="partNo">
            </mat-form-field>
        </ng-container>

        <!-- WRSV-only -->
        <ng-container *ngIf="valveGroup === 'wrsv'">
            <mat-form-field appearance="outline">
                <mat-label>Type of Retrievable Valve / Plug </mat-label>
                <mat-select formControlName="trsvType">
                    <mat-option *ngFor="let wrsvType of wrsvTypleList" [value]="wrsvType.name"> {{ wrsvType.name
                        }} </mat-option>
                </mat-select>
            </mat-form-field>

            <div class="col-span-2"></div>

            <mat-form-field appearance="outline">
                <mat-label>Initial Installed Date</mat-label>
                <input matInput [matDatepicker]="initialInstalledDatePicker" formControlName="initialInstalledDate">
                <mat-datepicker-toggle matSuffix [for]="initialInstalledDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #initialInstalledDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Part Number</mat-label>
                <input matInput formControlName="partNo">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Latest Installed Date</mat-label>
                <input matInput [matDatepicker]="latestInstalledDatePicker" formControlName="latestInstalledDate">
                <mat-datepicker-toggle matSuffix [for]="latestInstalledDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #latestInstalledDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Model</mat-label>
                <mat-select formControlName="model">
                    <mat-option [value]="'PXX'">PXX</mat-option>
                    <mat-option [value]="'PXN'">PXN</mat-option>
                    <mat-option [value]="'XXR'">XXR</mat-option>
                    <mat-option [value]="'BPV'">BPV</mat-option>
                    <mat-option [value]="'Nippless'">Nippless</mat-option>
                    <mat-option [value]="'Others'">Others</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Subsequent Installed Date</mat-label>
                <input matInput [matDatepicker]="subsequentInstalledDatePicker"
                    formControlName="subsequentInstalledDate">
                <mat-datepicker-toggle matSuffix [for]="subsequentInstalledDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #subsequentInstalledDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Installation Depth</mat-label>
                <input matInput formControlName="installationDepth">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Location</mat-label>
                <input matInput formControlName="installationAtSvlntrsv">
            </mat-form-field>
        </ng-container>

        <!-- Fields common to ALL groups including WRSV -->
        <mat-form-field appearance="outline">
            <mat-label>Size</mat-label>
            <span matTextSuffix>inches</span>
            <input matInput type="number" formControlName="sizeIn">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Equipment Brand / OEM</mat-label>
            <input matInput formControlName="equipmentBrand">
        </mat-form-field>

        <ng-container
            *ngIf="valveGroup !== 'standard' && valveGroup !== 'annulus' && valveGroup !== 'trsssv' && valveGroup !== 'wrsv'">
            <mat-form-field appearance="outline">
                <mat-label>Model</mat-label>
                <input matInput placeholder="" formControlName="model">
            </mat-form-field>
        </ng-container>

        <mat-form-field appearance="outline">
            <mat-label>Rating</mat-label>
            <span matTextSuffix>psi</span>
            <input matInput type="number" formControlName="ratingPsi">
            <mat-error *ngIf="form.get('ratingPsi')?.hasError('required')">Rating is required</mat-error>
        </mat-form-field>



        <!-- Annulus-only -->
        <ng-container *ngIf="valveGroup === 'annulus'">
            <div class="col-span-2 flex flex-col gap-1 mb-2">
                <mat-label class="font-medium text-sm text-gray-700">AVR Installed</mat-label>
                <mat-radio-group formControlName="isAvrInstalled" class="flex gap-4">
                    <mat-radio-button [value]="true" color="primary">Yes</mat-radio-button>
                    <mat-radio-button [value]="false" color="primary">No</mat-radio-button>
                </mat-radio-group>
            </div>
        </ng-container>

        <!-- Actuator fields: standard + annulus groups only -->
        <ng-container *ngIf="valveGroup === 'standard' || valveGroup === 'annulus'">
            <div class="col-span-2 flex flex-col gap-1 mb-2">
                <mat-label class="font-medium text-sm text-gray-700">Actuator Type</mat-label>
                <mat-radio-group formControlName="actuatorType" class="flex gap-4">
                    <mat-radio-button value="Pneumatic" color="primary">Pneumatic</mat-radio-button>
                    <mat-radio-button *ngIf="data.valveName != 'Surface Safety Valve'" value="Manual"
                        color="primary">Manual</mat-radio-button>
                    <mat-radio-button value="Hydraulic" color="primary">Hydraulic</mat-radio-button>
                </mat-radio-group>
            </div>

            <!-- Pneumatic fields -->
            <ng-container *ngIf="form.get('actuatorType')?.value === 'Pneumatic'">
                <mat-form-field appearance="outline" class="col-span-2">
                    <mat-label>Actuator Model</mat-label>
                    <input matInput formControlName="actuatorModel">
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Opening</mat-label>
                    <input matInput type="number" formControlName="openingSec">
                    <span matTextSuffix>seconds</span>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Opening</mat-label>
                    <input matInput type="number" formControlName="openingCm">
                    <span matTextSuffix>cm</span>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Closing</mat-label>
                    <input matInput type="number" formControlName="closingSec">
                    <span matTextSuffix>seconds</span>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Closing</mat-label>
                    <input matInput type="number" formControlName="closingCm">
                    <span matTextSuffix>cm</span>
                </mat-form-field>
            </ng-container>

            <!-- Manual fields -->
            <ng-container *ngIf="form.get('actuatorType')?.value === 'Manual'">
                <mat-form-field appearance="outline">
                    <mat-label>Fully Open <span class="text-xs text-gray-700">(as per specification)</span>
                    </mat-label>
                    <span matTextSuffix>turns</span>
                    <input matInput type="number" formControlName="fullyOpen">
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Fully Close <span class="text-xs text-gray-700">(as per specification)</span></mat-label>
                    <span matTextSuffix>turns</span>
                    <input matInput type="number" formControlName="fullyClose">
                </mat-form-field>
            </ng-container>

            <!-- Hydraulic fields -->
            <ng-container *ngIf="form.get('actuatorType')?.value === 'Hydraulic'">
                <mat-form-field appearance="outline" class="col-span-2">
                    <mat-label>Hydraulic Return</mat-label>
                    <span matTextSuffix>ml</span>
                    <input matInput formControlName="hydraulicReturn">
                </mat-form-field>
            </ng-container>
        </ng-container>



        <!-- TR-SSSV-only -->
        <ng-container *ngIf="valveGroup === 'trsssv'">
            <div class="flex flex-col gap-1 mb-2">
                <mat-label class="font-medium text-sm text-gray-700">Self Equalize</mat-label>
                <mat-radio-group formControlName="isSelfEqualize" class="flex gap-4">
                    <mat-radio-button [value]="true" color="primary">Yes</mat-radio-button>
                    <mat-radio-button [value]="false" color="primary">No</mat-radio-button>
                </mat-radio-group>
            </div>

            <div class="flex flex-col gap-1 mb-2">
                <mat-label class="font-medium text-sm text-gray-700">Locked Open</mat-label>
                <mat-radio-group formControlName="isLockedOpen" class="flex gap-4">
                    <mat-radio-button [value]="true" color="primary">Yes</mat-radio-button>
                    <mat-radio-button [value]="false" color="primary">No</mat-radio-button>
                </mat-radio-group>
            </div>
        </ng-container>

        <ng-container *ngIf="valveGroup !== 'standard' && valveGroup !== 'annulus' && valveGroup !== 'trsssv'">
            <mat-form-field appearance="outline" class="col-span-2">
                <mat-label>Remark</mat-label>
                <textarea matInput formControlName="remark" rows="3"></textarea>
            </mat-form-field>
        </ng-container>

        <ng-container *ngIf="valveGroup === 'xmasTree'">
            <div class="divider col-span-2">Tree Cap Connection Details</div>
            <mat-form-field>
                <mat-label class="flex items-center"> Tree Cap Connection </mat-label>
                <mat-select matNativeControl formControlName="treecapConn">
                    <mat-option value="BOWEN"> BOWEN </mat-option>
                    <mat-option value="OTIS"> OTIS </mat-option>
                    <mat-option value="OTHERS"> OTHERS </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field>
                <mat-label class="flex items-center"> If Others </mat-label>
                <input matInput placeholder="" formControlName="treecapConnRemarks">
            </mat-form-field>

            <mat-form-field>
                <mat-label class="flex items-center"> Size </mat-label>
                <input matInput placeholder="" type="number" step="0.01" min="0" formControlName="treeCapConnSize"
                    (blur)="formatDecimal(form.get('treeCapConnSize').value)">
                <span matTextSuffix>inches</span>
            </mat-form-field>

            <mat-form-field>
                <mat-label class="flex items-center"> Thread </mat-label>
                <input matInput placeholder="" formControlName="treeCapConnThread">
            </mat-form-field>

            <mat-form-field class="col-span-2"> 
                <mat-label class="flex items-center "> Description </mat-label>
                <textarea matInput placeholder="" formControlName="treeCapDescription"></textarea>
            </mat-form-field>
        </ng-container>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline mx-4" mat-dialog-close>Cancel</button>
    <button class="btn btn-primary text-white" [disabled]="form.invalid || form.pristine" (click)="onUpdate()">
        Update
    </button>
</mat-dialog-actions>

<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>